/**
 * Accessibility Utilities
 * Reusable className helpers for focus rings and hit areas
 */

/**
 * Standard focus ring (WCAG 2.2 compliant)
 * Uses design token --et-focus-ring
 */
export const focusRing = 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus focus-visible:ring-offset-2';

/**
 * Focus ring for elements within cards/surfaces
 * Uses offset to prevent overlap with borders
 */
export const focusRingInset = 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus focus-visible:ring-inset';

/**
 * Minimum hit area (32×32px) for touch targets
 * WCAG 2.2 Level AA requirement
 */
export const hitArea = 'min-h-[32px] min-w-[32px]';

/**
 * Comfortable hit area (44×44px) - preferred
 * Exceeds WCAG requirements for better UX
 */
export const hitAreaComfortable = 'min-h-[44px] min-w-[44px]';

/**
 * Combined focus + hit area for interactive elements
 */
export const interactiveElement = `${focusRing} ${hitArea}`;

/**
 * Combined focus + comfortable hit area
 */
export const interactiveElementComfortable = `${focusRing} ${hitAreaComfortable}`;

/**
 * Skip link styles (for keyboard navigation)
 */
export const skipLink = 'sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-md';

/**
 * Visually hidden but accessible to screen readers
 */
export const srOnly = 'sr-only';

/**
 * Screen reader only text that's revealed on focus
 */
export const srOnlyFocusable = 'sr-only focus:not-sr-only';
